import { render, staticRenderFns } from "./OralExpressionClose.vue?vue&type=template&id=21b24d90&scoped=true&"
import script from "./OralExpressionClose.vue?vue&type=script&lang=js&"
export * from "./OralExpressionClose.vue?vue&type=script&lang=js&"
import style0 from "./OralExpressionClose.vue?vue&type=style&index=0&id=21b24d90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b24d90",
  null
  
)

export default component.exports